import {createAction} from 'web-app/util/redux/famly-app-helpers';

import type * as Types from '../types';

const domain = 'IMPORT_MODAL';

export const {action: reset} = createAction(`${domain}/RESET`, () => ({}));

export const {action: updateImportModalState} = createAction(
    `${domain}/SHOW_IMPORT_MODAL`,
    (
        payload:
            | {
                  modalState: Types.ImportModalState.ImportFinished;
                  remainingRows?: Types.SpreadsheetData;
                  results?: Types.ImportResult[];
              }
            | {modalState: Types.ImportModalState.Hidden}
            | {modalState: Types.ImportModalState.Importing},
    ) => ({
        payload,
    }),
);
